import React from "react";
import { FaPaperPlane } from "react-icons/fa";
const STATUS_UI = {
  Start: {
    badge: "Start",
    badgeClass: "bg-gray-200 text-gray-800",
    cardClass: "bg-gray-50 border-gray-300",
    icon: "🚀",
  },

  Achieved: {
    badge: "Achieved",
    badgeClass: "bg-green-200 text-green-800",
    cardClass: "bg-green-50 border-green-300",
    icon: "✅",
  },

  Current: {
    badge: "Current",
    badgeClass: "bg-blue-200 text-blue-800",
    cardClass: "bg-blue-50 border-blue-500 ring-2 ring-blue-300",
    icon: "📍",
  },

  Upcoming: {
    badge: "Ongoing",
    badgeClass: "bg-orange-100 text-orange-700",
    cardClass: "bg-white border-orange-300",
    icon: <FaPaperPlane className="text-xs" />,
  },
};

function MilestoneCard({ data }) {
  const ui = STATUS_UI[data.status] || STATUS_UI.Upcoming;

  const increaseValue = parseFloat(data.increase || 0);
  const isNegative = increaseValue < 0;

  return (
    <div
      className={`rounded-xl p-4 shadow border hover:shadow-md transition-shadow h-[180px] flex flex-col
        ${ui.cardClass}
      `}
    >
      {/* Header */}
      <div className="flex justify-end items-center mb-1 flex-shrink-0">
        <span
          className={`text-xs px-2 py-1 rounded-full font-medium ${ui.badgeClass}`}
        >
          {ui.badge}
        </span>
      </div>

      <div className="flex-1 flex flex-col">
        {data.status === "Upcoming" && (
          <p className="text-xs text-gray-700 mb-1 font-medium">
            Ongoing Milestone
          </p>
        )}

        {/* Rating */}
        <p className="text-xl font-bold text-yellow-600 flex items-center gap-1 mb-1">
          ⭐ {data.rating}
        </p>

        {/* Required 5⭐ (only for Upcoming) */}
        {data.status === "Upcoming" && data.requiredFiveStar > 0 && (
          <p className="text-[10px] text-gray-500 mb-1">
            {data.requiredFiveStar} five-star reviews needed
          </p>
        )}

        {/* Increase / Decrease */}
        <p
          className={`text-xs mb-1 ${
            isNegative ? "text-red-600" : "text-green-600"
          }`}
        >
          {isNegative ? "↘" : "↗"} {isNegative ? "" : "+"}
          {data.increase}
        </p>
      </div>

      {/* Action */}
      <p className="text-[10px] text-blue-600 flex items-center gap-1 mt-auto flex-shrink-0">
        {typeof ui.icon === "string" ? <span>{ui.icon}</span> : ui.icon}
        <span>{data.action}</span>
      </p>
    </div>
  );
}

export default MilestoneCard;
